import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { ButtonComponent } from "@components/button/button.component";
import { InputNumberComponent } from "@components/input-number/input-number.component";
import { SelectorComponent } from "@components/selector/selector.component";
import { TranslatePipe } from "@ngx-translate/core";
import { map } from "rxjs/operators";
import { IValidationContext } from "~app/common/validation/IValidationContext";
import { IHandelssortimentProdukt, IProdukt } from "~app/features/forsaljning/handelssortiment/handelssortiment.models";
import { FormBinderService } from "../../../../../../common/services/form-binder.service";
import { HandelssortimentService } from "../../../handelssortiment.service";

@Component({
    selector: "rask-handelssortiment-produkt-rad",
    styleUrls: ["./produkt-rad.component.scss"],
    templateUrl: "./produkt-rad.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        SelectorComponent,
        ButtonComponent,
        InputNumberComponent,
        TranslatePipe
    ]
})
export class ProduktRadComponent implements OnInit {
    @Input() disabled: boolean;
    form: UntypedFormGroup;
    @Input() handelssortimentsgruppId: number;
    @Input() index: number;
    @Input() produkt: IHandelssortimentProdukt;
    @Output() produktChange = new EventEmitter<IHandelssortimentProdukt>();
    @Output() produktRemoved = new EventEmitter<IHandelssortimentProdukt>();
    @Input() produkter: IHandelssortimentProdukt[];
    @Input() validationContext: IValidationContext;

    private readonly fbs = inject(FormBinderService);
    private readonly handelssortimentService = inject(HandelssortimentService);
    private readonly router = inject(Router);

    exclude = () => this.produkter.map(hp => ({ id: hp.produktId } as IProdukt));

    getRule(ruleName: string) {
        return this.validationContext.current[ruleName + this.index];
    }

    navigateToProdukt() {
        const url = this.router.serializeUrl(this.router.createUrlTree([
            "core/produkt",
            this.produkt.produktId
        ]));
        window.open(url, "_blank");
    }

    ngOnInit() {
        this.form = this.fbs.CreateGroup(this.produkt, null, this.produktChange);
        if (this.disabled) {
            this.form.disable();
        }
    }

    produktFormatter = (produkt: IProdukt) => produkt ? `${produkt.namn} ${produkt.beteckning} ${produkt.prodgrupp}` : null;

    produktInaktiv = (produkt: IProdukt) => !produkt.aktiv;

    produktOutput = (produkt: IProdukt) => produkt ? produkt.id : undefined;

    removeHandelssortimentProdukt() {
        if (this.disabled) {
            return;
        }
        this.produktRemoved.emit(this.produkt);
    }

    searchForProdukt = (searchString: string) =>
        this.handelssortimentService.getProduktLista(this.handelssortimentsgruppId).pipe(
            map(pl => pl.filter(p => p.namn.toLowerCase().indexOf(searchString.toLowerCase()) > -1)));

    searchFordelningstyper = (searchString: string) =>
        this.handelssortimentService.getFordelningstyper().pipe(
            map(ft => ft.filter(f => f.toLowerCase().indexOf(searchString.toLowerCase()) > -1)));
}
